import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20fdce31"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 0,
  class: "sw-work-card--rank"
}
const _hoisted_5 = {
  key: 1,
  class: "sw-work-card--ornament"
}
const _hoisted_6 = { class: "sw-work-card--chips" }
const _hoisted_7 = { class: "sw-work-card--meta" }
const _hoisted_8 = { class: "sw-work-card--meta-col1" }
const _hoisted_9 = { class: "sw-work-card--meta-genre" }
const _hoisted_10 = {
  key: 0,
  class: "sw-work-card--meta-series"
}
const _hoisted_11 = { class: "sw-work-card--meta-col2" }
const _hoisted_12 = { class: "sw-work-card--title" }
const _hoisted_13 = { class: "sw-work-card--author" }
const _hoisted_14 = {
  key: 0,
  class: "sw-work-card--status"
}

import {
  computed,
  withDefaults,
  watch,
  onMounted,
  toRefs,
  ref,
} from 'vue';
import { CHANGE_FAVORITE_PRODUCTION_MUTATION, useStore } from '@/store';
import useFormatFunc from '@/components/utils/Formatter';
import useProductionsFunc from '@/components/utils/ProductionsUtil';
import SwAvatar from '@/components/molecules/SwAvatar.vue';
import SwFavoriteButton from '@/components/molecules/Buttons/SwFavoriteButton.vue';
import SwChip from '@/components/molecules/SwChip.vue';
import SwOrnament from '@/components/molecules/SwOrnament.vue';
import { FavoriteProductions, Productions } from '@/api/spotwrite';
import { WorkRouteRecordNameType } from '@/types/ui-components';
import FavoriteService from '@/api/FavoriteService';

interface Props {
  item?: Productions;
  thumbWidth?: number;
  rank?: number;
  routeRecordName?: WorkRouteRecordNameType;
  hideStatus?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SwWorkCard',
  props: {
    item: { default: undefined },
    thumbWidth: { default: 100 },
    rank: { default: undefined },
    routeRecordName: { default: 'workDetail' },
    hideStatus: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props as { item: Productions, thumbWidth: number, rank: number, routeRecordName: WorkRouteRecordNameType, hideStatus: boolean }

const store = useStore();
const me = computed(() => store.state.me);

const utils = useProductionsFunc();
const formatter = useFormatFunc();



const thumbHeight = () => props.thumbWidth * 1.412;

/**
 * class 属性
 */
const classes = computed(() => ({
  'sw-work-card': true,
  'has-series': !!utils.hasSeries(props.item),
  'has-image-error': !!utils.hasImageError(props.item),
}));

const publishedStatusClass = computed(() => ({
  disabled: !!props.item.published,
}));

const circleStatusClass = computed(() => ({
  disabled: true,
}));
const { item } = toRefs(props);

const myFavorite = ref<FavoriteProductions>();
const isMyFavorite = computed(() => !!myFavorite.value);

/**
 * 表示データ取得
 */
const fetchData = async () => {
  if (me.value?.id && item.value?.id) {
    // お気に入りがある？
    myFavorite.value = await FavoriteService.get(item.value.id, me.value.id);
  }
};
watch(me, async () => {
  await fetchData();
});
watch(item, async () => {
  await fetchData();
});

/**
 * ログインユーザが作品の投稿者である場合はtrue
 */
const isOwn = computed(() => {
  if (me.value && item.value) {
    if (me.value.id === item.value.userId) {
      return true;
    }
  }
  return false;
});

/**
 * style 属性
 */
const thumbStyle = computed(() => ({
  width: props.thumbWidth ? `${props.thumbWidth}px` : undefined,
  height: thumbHeight() ? `${thumbHeight()}px` : undefined,
}));

const onClickFavoriteButton = async () => {
  console.log('onChangeMyFavorite');
  if (me.value?.id && item.value?.id) {
    myFavorite.value = await FavoriteService.get(item.value.id, me.value.id);
    if (myFavorite.value) {
      console.log('del favorite');
      await FavoriteService.delete({
        userId: me.value.id,
        productionId: item.value.id,
      });
      // 変更を通知
      store.commit(CHANGE_FAVORITE_PRODUCTION_MUTATION, {
        userId: me.value.id,
        productionId: item.value.id,
        isOn: false,
      });
      myFavorite.value = undefined;
    } else {
      // 追加
      console.log('add favorite');
      myFavorite.value = await FavoriteService.insert({
        userId: me.value.id,
        productionId: item.value.id,
      });
      // 変更を通知
      store.commit(CHANGE_FAVORITE_PRODUCTION_MUTATION, {
        userId: me.value.id,
        productionId: item.value.id,
        isOn: true,
      });
    }
  }
};

onMounted(async () => {
  await fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(classes))
  }, [
    _createElementVNode("div", {
      class: "sw-work-card--thumb",
      ref: "thumb",
      style: _normalizeStyle(_unref(thumbStyle))
    }, [
      _createVNode(_component_router_link, {
        to: { name: __props.routeRecordName, params: { workId: _unref(item)?.id }}
      }, {
        default: _withCtx(() => [
          (_unref(utils).getCoverImage(_unref(item)))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(utils).getCoverImage(_unref(item)),
                alt: _unref(item)?.title
              }, null, 8, _hoisted_1))
            : _createCommentVNode("", true),
          (!_unref(utils).getCoverImage(_unref(item)) && !_unref(utils).hasImageError(_unref(item)))
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: require('@/assets/img/no-work-image.png'),
                alt: _unref(item)?.title
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true),
          (!_unref(utils).getCoverImage(_unref(item)) && _unref(utils).hasImageError(_unref(item)))
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                src: require('@/assets/img/has-error-image-small.png'),
                alt: _unref(item)?.title
              }, null, 8, _hoisted_3))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["to"]),
      (__props.rank)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(__props.rank), 1)
          ]))
        : _createCommentVNode("", true),
      (_unref(utils).isEnteredGpOne(_unref(item)))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(SwOrnament, { label: "グランプリエントリー" })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(SwChip, {
          icon: "sw-icon-like",
          label: _unref(formatter).formatNum(_unref(utils).favoriteCount(_unref(item)))
        }, null, 8, ["label"]),
        _createVNode(SwChip, {
          icon: "sw-icon-chat",
          label: _unref(formatter).formatNum(_unref(utils).commentCount(_unref(item)))
        }, null, 8, ["label"])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(utils).getGenreNames(_unref(item))), 1),
        (_unref(utils).hasSeries(_unref(item)))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_unref(utils).getSeriesName(_unref(item))), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(SwFavoriteButton, {
          on: _unref(isMyFavorite),
          onClick: onClickFavoriteButton
        }, null, 8, ["on"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_router_link, {
        to: { name: __props.routeRecordName, params: { workId: _unref(item)?.id }}
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(item)?.title), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createVNode(_component_router_link, {
        to: { name: 'userDetail', params: { userId: _unref(item).userId }}
      }, {
        default: _withCtx(() => [
          _createVNode(SwAvatar, {
            "icon-url": _unref(utils).getAuthorIconUrl(_unref(item)),
            name: _unref(utils).getAuthorNickname(_unref(item))
          }, null, 8, ["icon-url", "name"])
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    (!__props.hideStatus && _unref(isOwn))
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", {
            class: _normalizeClass(_unref(publishedStatusClass))
          }, "公開", 2),
          _createElementVNode("div", {
            class: _normalizeClass(_unref(circleStatusClass))
          }, "サークル", 2)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})